import React, { useState, useEffect } from "react";

export const svg = `<svg viewBox="0 0 114 108" class="createSvgIcon__Svg-sc-1l8xi8d-0 loXvaP"><path opacity=".5" d="M103.5 97h5.181l-2.579-4.494-46.5-81L57 6.974l-2.602 4.532-46.5 81L5.318 97H103.5Z" stroke="var(--shade0)" stroke-width="6"></path><path d="M40.5 106h33l1.5 1v1H39v-1l1.5-1Z" fill="var(--shade0)"></path><path opacity=".25" d="M78 104.5h-1.75l-3.75-3h-12L57 98l-3.5 3.5h-12l-3.75 3H36" stroke="var(--shade0)"></path><path d="M66 101.5h-5.5L57 98l-3.5 3.5H48" stroke="var(--shade0)"></path><path opacity=".25" fill-rule="evenodd" clip-rule="evenodd" d="M64.5 105H73v-.8l-1.5-1.2H63v.8l1.5 1.2ZM46 103h-3.5l-1.5 1.2v.8h8.5l1.5-1.2v-.8h-5Z" fill="var(--shade0)"></path><path fill="var(--shade0)" d="m57 101 1.5 1.5L57 104l-1.5-1.5zM30.652 34.21l-16.5 28.58-1.616.798-.866-.5 18-31.177.866.5.116 1.8Z"></path><path opacity=".25" d="m13.2 67.436.876-1.515 4.473-1.748 6-10.392L29.33 52.5l-1.281-4.781 6-10.392-.723-4.748.875-1.515" stroke="var(--shade0)"></path><path d="m21.799 58.544 2.75-4.763L29.33 52.5l-1.281-4.781 2.75-4.763" stroke="var(--shade0)"></path><path opacity=".25" fill-rule="evenodd" clip-rule="evenodd" d="m19.518 55.495-1.75 3.031-2.5 4.33.692.4 1.79-.699 1.75-3.03 2.5-4.33-.693-.4-1.79.698ZM30.5 40.474l1.75-3.032-.29-1.899-.692-.4-2.5 4.33-1.75 3.032.29 1.899.692.4 2.5-4.33Z" fill="var(--shade0)"></path><path fill="var(--shade0)" d="m26.732 51-2.049.549-.548-2.049 2.048-.549zm56.616-16.79 16.5 28.58 1.616.798.866-.5-18-31.177-.866.5-.116 1.8Z"></path><path opacity=".25" d="m100.799 67.436-.875-1.515-4.473-1.748-6-10.392L84.67 52.5l1.28-4.781-6-10.392.724-4.748-.875-1.515" stroke="var(--shade0)"></path><path d="m92.2 58.544-2.75-4.763-4.78-1.281 1.28-4.781-2.75-4.763" stroke="var(--shade0)"></path><path opacity=".25" fill-rule="evenodd" clip-rule="evenodd" d="m94.482 55.495 1.75 3.031 2.5 4.33-.693.4-1.789-.699-1.75-3.03-2.5-4.33.693-.4 1.789.698ZM83.5 40.474l-1.75-3.032.29-1.899.692-.4 2.5 4.33 1.75 3.032-.29 1.899-.692.4-2.5-4.33Z" fill="var(--shade0)"></path><path fill="var(--shade0)" d="m87.268 51 2.049.549.548-2.049-2.048-.549z"></path><path d="M103.5 95h1.727l-.86-1.498-46.5-81-.867-1.51-.867 1.51-46.5 81L8.773 95H103.5Z" stroke="var(--shade7)" stroke-width="2"></path></svg>`;

const contentRegExp = /<svg(.*?)>(.*?)<\/svg>/s;
const attrRegExp = /(.*?)="(.*?)"/;
const splitAttrExp = /[\w-]+="[^"]*"/g;

const attributeMap = {
  viewbox: "viewBox",
  class: "className",
};

let instanceId = 0;

function Icon(props) {
  const [, attrs, content] = svg.match(contentRegExp);

  const svgAttributes = {};

  for (const stringAttr of attrs.trim().match(splitAttrExp)) {
    let [, key, value] = stringAttr.match(attrRegExp);
    if (key in attributeMap) key = attributeMap[key];
    svgAttributes[key] = value;
  }

  const [obj, setObj] = useState({ svgAttributes, __html: content });

  // On the client, unique IDs are necessary per instance.
  // We will use the fact that React SSR does not run effects!
  useEffect(() => {
    const ids = svg.matchAll(/id="(.*?)"/gm);
    let html = obj.__html;

    for (const [match, id] of ids) {
      const uniqueID = `${id}-${instanceId}`;
      html = html
        .replace(match, 'id="' + uniqueID + '"')
        .replaceAll(`url(#${id})`, `url(#${uniqueID})`)
        .replaceAll(`"#${id}"`, `"#${uniqueID}"`);
    }

    setObj({ svgAttributes, __html: html });

    instanceId++;
  }, []);

  return (
    <svg
      dangerouslySetInnerHTML={obj}
      {...obj.svgAttributes}
      {...props}
    />
  );
}

export default Object.assign(Icon, { svg });
